var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from 'react';
import IconFlagFactory from 'react-flag-icon-css';
var selfStyles = require('./IconFlag.scss');
var Flag = IconFlagFactory(React);
var IconFlag = function (props) { return (React.createElement(Flag, __assign({}, props, { className: selfStyles.flag }))); };
export default IconFlag;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/IconFlag.tsx
// module id = 410
// module chunks = 0